import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=7078a076&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=7078a076&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078a076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7078a076')) {
      api.createRecord('7078a076', component.options)
    } else {
      api.reload('7078a076', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=7078a076&scoped=true", function () {
      api.rerender('7078a076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main-tabs/Home.vue"
export default component.exports